handleRemoveUserProfileImages